enum BiteLogSimpleEvent {
  Unrecognized = -1,
  SimpleStatusOk = 0,
}

export { BiteLogSimpleEvent };
